/*
 * Forge Maestro
 * (c) Honeywell
 */

const isEmpty = (value) => value === undefined ||
    value === null ||
    value.length === 0 ||
    (typeof value === 'string' && value.trim().length === 0);
const isNotEmpty = (value) => !isEmpty(value);

export { isEmpty, isNotEmpty };
//# sourceMappingURL=is-empty.js.map
